import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';
import { IdbService } from '../services/idb.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private idbService: IdbService, private router: Router, private httpClient: HttpClient) {}

  /**
   * For now it's not used, maybe later
   *
   * @param {ActivatedRouteSnapshot} next
   * @param {RouterStateSnapshot} state
   * @returns {( Promise<boolean> )}
   * @memberof AuthGuard
   */
  canActivate(): Promise<boolean> {
    return this.checkLogin();
  }

  /**
   * Check for the child route
   *
   * @param {ActivatedRouteSnapshot} childRoute
   * @param {RouterStateSnapshot} state
   * @returns {( Promise<boolean>)}
   * @memberof AuthGuard
   */
  canActivateChild(): Promise<boolean> {
    return this.checkLogin();
  }

  private checkLogin(): Promise<boolean> {
    const url = {
      admin: environment.apiUrl + 'admin/'
    };
    return new Promise((resolve, reject) => {
      this.httpClient
        .get(url.admin + 'me')
        .toPromise()
        .then((user: User) => {
          if (user.isAdmin) {
            resolve(true);
          }
          resolve(false);
        })
        .catch((error) => {
          if (error.status === 401) {
            this.router.navigate(['/login']);
          }
        });
    });
  }
}
